package ru.villawonka.app.platform

import kotlinx.browser.window
import ru.villawonka.app.platform.platform.Platform
import ru.villawonka.app.platform.platform.model.DeviceInfo
import ru.villawonka.app.platform.platform.model.PlatformType
import ru.villawonka.app.uaparser.UAParser

class JsPlatform: Platform {

    override val type: PlatformType = PlatformType.TELEGRAM

    override val deviceInfo: DeviceInfo = UAParser.parse(window.navigator.userAgent)
}